import styled from 'styled-components';

export const ActionItemText = styled.span`
`;
